import React, { useState, useEffect } from "react";
import CropForm from "./CropForm";
import UseTables from "./Employees2";
import { useHistory, Redirect, useParams } from "react-router-dom";
import OpacityIcon from "@material-ui/icons/Opacity";
import axios from "axios";
const isISODate = require("is-iso-date");

export default function Crops(props) {
  const { id: farmerId } = useParams();
  const initialTitle = "Crop";
  const header = "Crops";
  const initialApiEndpoint = "/harvest";
  // const secondaryApiEndpoint = `/harvest/farmer/${farmerId}`;
  const history = useHistory();
  const extraColumns = [
    { name: "name", label: "Crop", options: { filter: false } },
    {
      name: "landExtent",
      label: "Land Extent in Acres",
      options: { filter: false },
    },
    {
      name: "expectedHarvest",
      label: "Expected Harvest in kg",
      options: { filter: false },
    },
    { name: "month", label: "Month", options: { filter: false } },
    { name: "year", label: "Year", options: { filter: false } },
  ];

  // const table = useTables(
  //   initialTitle,
  //   initialApiEndpoint,
  //   extraColumns,
  //   EmployeeForm
  // );
  return (
    <>
      <UseTables
        initialTitle={initialTitle}
        header={header}
        Icon={OpacityIcon}
        initialApiEndpoint={initialApiEndpoint}
        // secondaryApiEndpoint={secondaryApiEndpoint}
        farmerId={farmerId}
        extraColumns={extraColumns}
        Form={CropForm}
        searchBox={false}
        districtFilter={false}
        cropTypeFilter={false}
        startDateFilter={true}
        endDateFilter={true}
      />
    </>
  );
}
